import React from "react";
import { Grid, Stepper, Step, StepLabel } from "@material-ui/core";
import StepConnector from "@material-ui/core/StepConnector";
import { withStyles } from "@material-ui/core/styles";

const Connector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  active: {
    "& $line": {
      borderColor: "#1E88E5",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#1E88E5",
    },
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

export const InboundStepperProgress = ({
  getActiveStep,
  getSteps,
  isStepFailed,
  isStepCompleted,
}) => {
  return (
    <Grid item xs={12}>
      <Stepper
        activeStep={getActiveStep()}
        alternativeLabel
        connector={<Connector />}
      >
        {getSteps().map((label, index) => {
          const stepProps = {};
          const labelProps = {};

          labelProps.error = isStepFailed(index);
          stepProps.completed = isStepCompleted(index);

          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Grid>
  );
};
